export const STYLES = {
  INDEX: {
    layoutStyle:
      'flex flex-col w-full h-full pt-[96px] pb-[24px] pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pr-[70px] bg-bw02',
    navbarStyle: 'flex items-start mb-6 mt-[-15px]',
    titleStyle: 'text-bw08 font-metricMedium text-xl',
    backButtonStyle: 'flex items-center justify-center w-[2rem] mr-[16px]',
  },
  PRE_LOAD: {
    wrapper: 'w-[100%] h-full bg-bw00 flex items-center justify-center rounded-[8px]',
  },
  INTRO: {
    wrapper: 'w-[100%] h-full bg-bw00 flex flex-col rounded-[8px]',
    header: 'px-[24px] py-[18px] border-b border-bw03 font-metricRMedium',
    contentContainer: 'w-full grow flex flex-col items-center justify-center px-[30px] pb-[12px]',
    icon: 'mb-[14px] w-[170px] h-[170px]',
    mainTitle: 'mb-[10px] font-metricR text-bw08 text-[22px]',
    subTitle: 'mb-[18px] font-metricR text-bw07 text-[16px] text-center',
    footer: 'h-[82px] border-t border-bw03',
  },
  DASHBOARD: {
    wrapper: 'w-[840px] h-fit pl-[10px] flex items-start gap-[25px] fadeIn',
    leftContainer: 'flex flex-col gap-[18px] basis-3/5',
    rightContainer: 'h-[490px] basis-2/5 bg-bw00 rounded-[8px]',
    balanceControllerContainer: 'w-full h-fit pt-[60px] pb-[24px] max-h-[40%] bg-bw00 rounded-[8px]',
    savingsControllerContainer: 'w-full h-fit bg-bw00 rounded-[8px]',
    disclaimer: 'font-metricR text-bw06 text-[14px] max-w-[480px] mt-[36px] ml-[15px]',
  },
  SETUP_BUCKET: {
    wrapper: 'pt-[50px] pb-[12px] min-h-[448px] px-[40px] bg-bw00 w-[360px] rounded-[8px] flex flex-col items-center',
    mainTitle: 'font-metricRSemibold text-[18px] text-bw08 mb-[8px]',
    subTitle: 'font-metricR text-[14px] text-center text-bw07 mb-[60px]',
    currencyInput:
      'w-[240px] mb-[14px] mx-[auto] h-[50px] bg-bw00 box-border border border-bw02 focus:border-action03 outline-none px-[8px] rounded-md font-metricR text-[25px] text-bw08 text-center',
    amount: 'font-metricRSemibold text-[44px] text-action03',
    inputErrorMessage: 'font-metricR text-sm leading-[16px] text-red02 fadeIn mb-[60px] text-center',
    feePeriodDisclaimer: 'font-metricR text-[16px] text-bw05 mb-[60px]',
    disclaimer: 'font-metricR text-[14px] text-bw07 text-center',
  },
  MOVE_MONEY: {
    wrapper: 'pt-[50px] pb-[50px] min-h-[448px] px-[40px] bg-bw00 w-[360px] rounded-[8px] flex flex-col items-center',
    mainTitle: 'font-metricRMedium text-[18px] text-bw08 leading-[24px] mb-[8px]',
    amountValue: 'font-metricRMedium text-action03 text-[18px]',
    amountLeft: 'font-metricR text-[16px] text-bw06',
    amountLeftLastLine: 'mb-[42px]',
    currencyInput:
      'w-full mb-[14px] mx-[auto] h-[50px]  box-border border border-[1px] border-bw02 focus:border-action03 outline-none px-[8px] rounded-md font-metricR text-[25px] text-bw08 text-center',
    errorMessage: 'font-metricR text-[12px] leading-[16px] text-red02 fadeIn text-center',
    cta: 'w-full mt-auto',
  },
  BALANCE_CONTROLLER: {
    TT:
      'fadeIn before:w-[10px] before:h-[10px] before:bg-bw00 before:border-bw04 before:border-b before:border-r before:absolute\n' +
      '        before:left-[50%] before:translate-x-[-50%] before:rotate-[45deg] before:translate-y-[55%] before:bottom-0 absolute z-[9999] top-0 left-[50%] translate-x-[-50%]\n' +
      '        translate-y-[calc(-100%-10px)] bg-bw00 border border-bw04 px-[12px] py-[6px] rounded-[6px] shadow-light flex items-center justify-center w-[286px]',
  },
};
export const STEPS = {
  PRE_LOAD: 'preLoad',
  INTRO: 'intro',
  DASHBOARD: 'dashboard',
  SETUP: 'setup',
  MONEY_MOVEMENT: 'moneyMovement',
  TRANSACTIONS: 'transactions',
};

export const STEPS_TO_HIDE_NAVBAR = [STEPS.PRE_LOAD, STEPS.INTRO];
